export function calcDoc(lines, tvaPct = 0, remisePct = 0, acompte = 0) {
  const sub       = lines.reduce((s, l) => s + l.qty * l.prix, 0);
  const remiseAmt = sub * remisePct / 100;
  const apRes     = sub - remiseAmt;
  const tvaAmt    = apRes * tvaPct / 100;
  const total     = apRes + tvaAmt;
  const restant   = total - acompte;
  return { sub, remisePct, remiseAmt, tvaPct, tvaAmt, apRes, total, acompte, restant };
}

export function fmt(n) {
  return Number(n).toLocaleString('fr-FR') + ' FCFA';
}

export function genNum(prefix) {
  const year = new Date().getFullYear();
  const rand = String(Math.floor(Math.random() * 900) + 100).padStart(3, '0');
  return `${prefix}-${year}-${rand}`;
}

export function today() {
  return new Date().toISOString().split('T')[0];
}

function filterTx(transactions = [], filter = {}) {
  return transactions.filter(t => {
    if (!t) return false;
    if (filter.day   && t.date?.slice(0,10) !== filter.day)   return false;
    if (filter.month && t.date?.slice(0,7)  !== filter.month) return false;
    if (filter.year  && t.date?.slice(0,4)  !== filter.year)  return false;
    return true;
  });
}

export function repartitionParRubrique(transactions = [], filter = {}) {
  const tx = filterTx(transactions, filter);

  // ── Protection si aucune transaction ────────────────────
  if (!tx || tx.length === 0) {
    return {
      total: 0,
      buckets: {
        factures:    { label: 'Factures',     total: 0, count: 0 },
        devis:       { label: 'Devis',        total: 0, count: 0 },
        acomptes:    { label: 'Acomptes',     total: 0, count: 0 },
        nonEncaisse: { label: 'Non encaissé', total: 0, count: 0 },
        comptes:     { label: 'Comptes',      total: 0, count: 0 },
      }
    };
  }

  const buckets = {
    factures:    { label: 'Factures payées',  total: 0, count: 0 },
    devis:       { label: 'Devis acceptés',   total: 0, count: 0 },
    acomptes:    { label: 'Acomptes reçus',   total: 0, count: 0 },
    nonEncaisse: { label: 'Non encaissé',     total: 0, count: 0 },
    encaissé:    { label: 'Encaissé',         total: 0, count: 0 },
    commandes:    { label: 'Commandes',       total: 0, count: 0 },
    etudiants:    { label: 'Etudiants',       total: 0, count: 0 },
    personnel:    { label: 'Personnel',       total: 0, count: 0 },
  };

  tx.forEach(t => {
    if (!t) return;
    const total   = Number(t.total)   || 0;
    const acompte = Number(t.acompte) || 0;
    const restant = Number(t.restant) || 0;
    const statut  = t.statut || '';
    const type    = t.type   || '';

    if (statut === 'payé') {
      if (type === 'facture') {
        buckets.factures.total += total;
        buckets.factures.count += 1;
      } else if (type === 'devis') {
        buckets.devis.total += total;
        buckets.devis.count += 1;
      }
    } else if (acompte > 0) {
      buckets.acomptes.total += acompte;
      buckets.acomptes.count += 1;
      if (restant > 0) {
        buckets.nonEncaisse.total += restant;
        buckets.nonEncaisse.count += 1;
      }
    } else if (statut !== 'annulé') {
      buckets.nonEncaisse.total += total;
      buckets.nonEncaisse.count += 1;
    }
  });

  const total = Object.values(buckets).reduce((s, b) => s + (b?.total || 0), 0);
  return { total, buckets };
}
